// Generated file: Do not edit 
// generated from @taqueria-protocol-types
    
import { TaqError, toFutureParseErr, toFutureParseUnknownErr, toParseErr, toParseUnknownErr } from '@taqueria/protocol/TaqError';
import { FutureInstance, resolve, reject } from 'fluture';
import { ZodError } from 'zod';
import { ConfigAccount } from '@taqueria/protocol/types';
import { ConfigAccount as ConfigAccountStrict } from '@taqueria/protocol/out/types-strict';
import { configAccountSchema } from '@taqueria/protocol/out/types-zod';

export type { ConfigAccountStrict as ConfigAccount };

export const from = (input: unknown): ConfigAccountStrict => {
	try {
		return configAccountSchema.parse(input) as ConfigAccountStrict;
	}
	catch (previous: unknown) {
		if (previous instanceof ZodError) {
			const msgs: string[] = previous.errors.reduce(
				(retval, issue) => {
					const path = issue.path.join(' → ');
					const msg = path + ': ' + issue.message;
					return [...retval, msg];
				},
				["ConfigAccount is invalid:"],
			);
			const validationErr = msgs.join('\n') + '\n';
			throw toParseErr(previous, validationErr);
		}
		throw toParseUnknownErr(previous, "There was a problem trying to parse a ConfigAccount.")
	}
    
};

export const create = (input: ConfigAccount): ConfigAccountStrict => from(input);

export const of = (input: unknown): FutureInstance<TaqError, ConfigAccountStrict> => {
	try {
		return resolve(from(input))
	}
	catch (err){
		return reject(err) as FutureInstance<TaqError, never>
	}
};

export const make = (input: Omit<ConfigAccountStrict, '__type'>): FutureInstance<TaqError, ConfigAccountStrict> => of(input);

// TEMP: for interoperation with old protocol types during transition
export const schemas = {
	rawSchema: configAccountSchema,
	schema: configAccountSchema.transform(val => val as ConfigAccountStrict),
};
export const rawSchema = schemas.rawSchema;
export const internalSchema = configAccountSchema;

export type t = ConfigAccountStrict;
        